import React, { useCallback } from 'react';

import { Tag, TagSkin } from 'wix-ui-tpa/cssVars';

import { st, classes } from './TextOption.st.css';

export const TextOption: React.FC<{
  text: string;
  onClick?: (value: string) => void;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
}> = ({ text, selected, disabled, className, onClick }) => {
  const handleClick = useCallback(() => {
    onClick?.(text);
  }, [onClick, text]);

  return (
    <Tag
      className={st(classes.root, { selected, disabled }, className)}
      skin={TagSkin.light}
      onClick={disabled ? undefined : onClick && handleClick}
    >
      {text}
    </Tag>
  );
};
